import React from "react";
import s from "./Radio.module.css";
import { clsx } from "../../utils/clsx";

export default function Radio({ label, className, ...rest }) {
  return (
    <label className={clsx(s.row, className)}>
      <input type="radio" className={s.dot} {...rest} />
      <span>{label}</span>
    </label>
  );
}
